<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Activity Section Heading</h2>
      <p class="text-sm text-gray-500">
        Headings above the donor/campaign activity feed. The feed data itself is campaign-specific
        and not editable here.
      </p>
    </header>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Eyebrow</label>
      <input
        v-model="content.eyebrow"
        type="text"
        maxlength="120"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
      >
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Headline</label>
      <input
        v-model="content.headline"
        type="text"
        maxlength="250"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActivitySectionEditor',
  props: {
    content: { type: Object, required: true },
  },
};
</script>
